import {
    ADD_FEED_POSTS,
    GET_POSTS_SUCCESS,
    GET_FEEDS_SUCCESS,
    ADD_PAGE,
    SAVE_PAGE,
    TOGGLE_NO_MORE_POST,
    TOGGLE_NO_MORE_FEED,
    DELETE_POST,
    TOGGLE_NO_MORE_SHARED,
    GET_SHARED_SUCCESS,
    GET_FEEDS_POSTDATA,
    GET_CHANGE,
    SHAREDTOME_COUNT
} from "../actions/userReflection";

const initialState = {
    loading: true,
    reflections: [],
    groups: [],
    sharedPosts: [],
    page: 1,
    spage: 0,
    hasmore: true,
    groupData: {},
    change: false,
    shareMeMore: false,
    currentFeedFilter:null,
    currentGroupFilter:null
}

export const userReflectionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PAGE:
            return { ...state, page: state.page + 5 }
        case GET_POSTS_SUCCESS:
            return {
                ...state,
                loading: false,
                // reflections: [...state.reflections, ...action.reflections],
                reflections: action.reflections,
                hasmore: true
            }
        case TOGGLE_NO_MORE_POST:
            return {
                ...state, loading: false,
                // reflections: [...state.reflections, ...action.reflections],
                reflections: action.reflections,
                hasmore: false
            }
        case GET_FEEDS_SUCCESS:
            return {
                ...state, loading: false,
                // reflections: [...state.reflections, ...action.payload.feeds],
                reflections: action.payload.feeds,
                groups: action.payload.groups,
                hasmore: true
            }
        case TOGGLE_NO_MORE_FEED:
            return {
                ...state, loading: false,
                //reflections: [...state.reflections, ...action.payload.feeds], 
                reflections: action.payload.feeds,
                groups: action.payload.groups,
                hasmore: false
            }
        case GET_SHARED_SUCCESS:
            return {
                ...state, loading: false,
                sharedPosts: [
                    ...state.sharedPosts,
                    ...action.payload.sharedPosts
                ],
                hasmore: true
            }
        case TOGGLE_NO_MORE_SHARED:
            return {
                ...state, loading: false,
                sharedPosts: [
                    ...state.sharedPosts,
                    ...action.payload.sharedPosts
                ],
                hasmore: false
            }
        case SHAREDTOME_COUNT:
            return {
                ...state,
                shareMeMore: action.payload
            }
        case ADD_FEED_POSTS:
            return {
                ...state,
                loading: false,
                reflections: [
                    ...state.reflections,
                    ...action.payload
                ],
            }
        case DELETE_POST:
            const newReflections = state.reflections.filter((post) =>
                ((post.reflection_id !== action.payload.post_id) || (post.group_id !== action.payload.group_id))
            )

            return {
                ...state,
                reflections: newReflections
            }
        case SAVE_PAGE:
            return { ...state, spage: state.page }
        case GET_FEEDS_POSTDATA:
            return {
                ...state, loading: false,
                groupData: action.payload.data
            }
        case GET_CHANGE:
            return {
                ...state, change: action.payload
            }
        case "feedFilter":
            return {
                ...state, currentFeedFilter: action.payload
            }
        case "groupFilter":
            return {
                ...state, currentGroupFilter: action.payload
            }
        default: return state
    }
}